type UserLike = {
  type?: string | null;
  is_sub_login?: boolean | null;
} | null | undefined;

export function canManageSubLogins(user: UserLike): boolean {
  if (!user) {
    return false;
  }

  return user.type === "proprietario" && user.is_sub_login !== true;
}

export function isSubLoginUser(user: UserLike): boolean {
  return Boolean(user?.is_sub_login);
}

/**
 * Owner-scoped UI/API access: master proprietario OR any linked sub-login,
 * even when the account type remains "inquilino".
 */
export function hasOwnerScopedAccess(user: UserLike): boolean {
  if (!user) {
    return false;
  }

  return isSubLoginUser(user) || user.type === "proprietario";
}

export function getPostLoginHomePath(user: UserLike): string {
  if (isSubLoginUser(user)) {
    return "/owner-dashboard";
  }

  return "/";
}
